import { render, staticRenderFns } from "./ModalAvenueOfFeedback.vue?vue&type=template&id=2229cd8e&"
import script from "./ModalAvenueOfFeedback.vue?vue&type=script&lang=js&"
export * from "./ModalAvenueOfFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports